export function getInitialStateHipoteca() {
   return {
      locaciones: [],
      locacionEditandoId: null,
      documentos: [],
      loading: false,
   };
}

export default getInitialStateHipoteca();
